import { useState, useEffect, useRef } from 'react';

interface UseImageLoadingReturn {
  isLoaded: boolean;
  showPlaceholder: boolean;
  hasError: boolean;
  imgRef: React.RefObject<HTMLImageElement>;
  handleImageLoad: () => void;
  handleImageError: () => void;
}

export const useImageLoading = (): UseImageLoadingReturn => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [showPlaceholder, setShowPlaceholder] = useState(true);
  const [hasError, setHasError] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    // Check if image is already loaded from cache
    if (imgRef.current?.complete) {
      setIsLoaded(true);
      setShowPlaceholder(false);
    }
  }, []);

  const handleImageLoad = () => {
    setIsLoaded(true);
    setShowPlaceholder(false);
  };

  const handleImageError = () => {
    setIsLoaded(false);
    setShowPlaceholder(false);
    setHasError(true);
  };

  return {
    isLoaded,
    showPlaceholder,
    hasError,
    imgRef,
    handleImageLoad,
    handleImageError,
  };
};
